import styled from 'styled-components'

export const Container = styled.div`
    /* max-width: 1440px; */
    padding: 20px;

    h1 {
        color: #333;
        font-family: 'Inter';
        font-weight: 500;
    }

    .bar {
        margin-top: 10px;
        overflow-x: auto;
        /* padding: 10px; */
        padding-bottom: 10px;
        width: 100%;
        ul {
            display: flex;
            align-items: center;
            border: 1px solid #d3d3d3;
            background: #fff;
            /* max-width: 700px; */
            /* box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px; */

            border-radius: 8px;
            width: min-content;

            li {
                font-family: 'Inter';
                font-size: 14px;
                font-weight: 400;
                text-align: center;
                white-space: nowrap;
                cursor: pointer;
                width: 100%;
                /* padding: 10px 12px; */

                a {
                    padding: 10px 12px;
                    display: inline-block;
                    color: #333;
                    width: 100%;
                }

                &:hover {
                    opacity: 0.8;
                }
            }

            li:not(:last-child) {
                border-right: 1px solid #d3d3d3;
            }
        }

        @media (min-width: 922px) {
            ul {
                width: auto;
            }
        }
    }
`

export const DialogOptIn = styled.div`
    padding: 10px;
    border-radius: 6px;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    /* border: 2px solid #4c83ee; */
    margin-bottom: 30px;

    h2 {
        font-family: 'Poppins', sans-serif;
        font-weight: 500;
        font-size: 34px;
        margin-bottom: 10px;
    }

    p {
        font-family: 'Inter', sans-serif;
        margin-bottom: 10px;

        > a {
            color: #4c83ee;
            &:hover {
                color: #566583;
            }
        }
    }

    .actions {
        display: flex;
        justify-content: flex-end;

        button {
            background: #4c83ee;
        }
    }
`

export const Content = styled.div`
    margin-top: 30px;
`
